import { TextField, useMediaQuery } from '@mui/material'
import React from 'react'
import AppTooltip from './AppTooltip'
import PasswordInfo from './PasswordInfo'

const PasswordField = (props) => {
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'))

    return (
        <>
            <AppTooltip title={<PasswordInfo />} placement="right" arrow>
                <TextField {...props} />
            </AppTooltip>
            {!matches && <PasswordInfo />}
        </>
    )
}
export default PasswordField
